import { Users, Snowflake, Mountain, ShieldCheck, Fuel, ArrowRight } from "lucide-react";
import { useEnquiry } from "./Enquiry";
import { img, IMG } from "@/data/images";
import { BUSINESS, waLink } from "@/data/business";
import Reveal from "./Reveal";

const FEATURES = [
  { icon: Users, title: "7 Seats + Luggage", desc: "Spacious family seating with real boot space for hill luggage." },
  { icon: Mountain, title: "Pahadi Hill Drivers", desc: "Local drivers who know every bend, viewpoint and dhaba." },
  { icon: Snowflake, title: "Full AC Comfort", desc: "Climate comfort from the Doon valley to the high passes." },
  { icon: ShieldCheck, title: "Hill-Safety First", desc: "Well-maintained Ertiga VXI with safety-focused driving on ghat roads." },
];

export default function ErtigaSection({ compact = false, destination }) {
  const { openEnquiry } = useEnquiry();
  return (
    <section id="fleet" className={compact ? "" : "section-pad"} data-testid="ertiga-fleet-section">
      <div className="container-x">
        <div className="grid items-center gap-10 lg:grid-cols-2 lg:gap-16">
          <Reveal>
            <div className="relative overflow-hidden rounded-3xl border border-gold/25">
              <img
                src={img(IMG.ertiga_fleet[0], 1200)}
                alt={`${BUSINESS.vehicle} — the Tingadya Travels taxi on a Himalayan viewpoint`}
                loading="lazy"
                className="aspect-[4/3] w-full object-cover"
              />
              <div className="absolute bottom-4 left-4 rounded-2xl border border-gold/40 bg-black/70 px-5 py-3 backdrop-blur-md">
                <p className="font-mono text-[10px] uppercase tracking-widest2 text-gold">Our Fleet</p>
                <p className="font-display text-lg font-bold text-white">{BUSINESS.vehicle}</p>
              </div>
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="eyebrow">Travel with Tingadya Travels</p>
            <h2 className="mt-3 font-display text-3xl font-bold text-white sm:text-4xl">
              The {BUSINESS.vehicle} — Built for Himalayan Journeys
            </h2>
            <p className="mt-4 leading-relaxed text-mist">
              One comfortable MPV, driven by people who grew up on these roads. Char Dham Yatra, weekend hill breaks or a glacier trek base — we plan the drive, the night halts and the pickups, and stay reachable on WhatsApp through the journey.
            </p>
            <div className="mt-8 grid gap-4 sm:grid-cols-2">
              {FEATURES.map((f) => (
                <div key={f.title} className="flex gap-3 rounded-2xl border border-white/10 bg-coal/70 p-4">
                  <f.icon size={20} className="mt-0.5 shrink-0 text-gold" />
                  <div>
                    <p className="text-sm font-semibold text-white">{f.title}</p>
                    <p className="mt-1 text-xs leading-relaxed text-mist">{f.desc}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:flex-wrap">
              <button onClick={() => openEnquiry(destination || "", "Fleet section")} data-testid="ertiga-get-price-button" className="btn-gold">
                Get Taxi Price <ArrowRight size={16} />
              </button>
              <a href={waLink("Hello Tingadya Travels! Please share taxi details and availability for the Ertiga.")} target="_blank" rel="noopener noreferrer" data-testid="ertiga-whatsapp-button" className="btn-ghost-gold">
                WhatsApp the Fleet Desk
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
